module.exports = __webpack_public_path__ + "img/stealth-mode-tracking.51012f76.png";